import { $_app_server } from '@/_helpers'

export const expertService = {
  getRegions,
  getRegion,
  saveCourtRegion,
  deleteRegion,
  saveCourt,
  deleteCourt,
  getQrCode,
  getBankInfo,
  getPaymentOrder,
  getPaymentOrderForUL,
  getQrCodeLog,
  getQrCodeLogByPage
}

const prefix = "specialist/expert"

function getRegions() {
  return $_app_server.get(`${prefix}/regions`).then(response => response.data)
}

function getRegion(alias) {
  return $_app_server.get(`${prefix}/region/${alias}`).then(response => response.data)
}

function saveCourtRegion(courtRegion) {
  return $_app_server.post(`${prefix}/region`, courtRegion).then(response => response.data)
}

function deleteRegion(id) {
  return $_app_server.delete(`${prefix}/region/${id}`)
}

function saveCourt(court) {
  return $_app_server.post(`${prefix}/court`, court).then(response => response.data)
}

function deleteCourt(id) {
  return $_app_server.delete(`${prefix}/court/${id}`)
}

function getQrCode(payment) {
  return $_app_server.post(`${prefix}/qrcode`, payment, { responseType: 'blob' }).then(response => response.data)
}

function getBankInfo(bic) {
  return $_app_server.get(`bic/${bic}`).then(response => response.data)
}

function getPaymentOrder(form) {
  return $_app_server.post(`${prefix}/payment`, form, { responseType: 'blob' }).then(response => response.data)
}

function getPaymentOrderForUL(form) {
  return $_app_server.post(`${prefix}/for1c`, form, { responseType: 'blob' }).then(response => response.data)
}

function getQrCodeLog() {
  return $_app_server.get(`${prefix}/log`).then(response => response.data)
}

function getQrCodeLogByPage(pageNum) {
  return $_app_server.get(`${prefix}/log/${pageNum}`).then(response => response.data)
}
